// extracted by mini-css-extract-plugin
module.exports = {"p":"AdFormatSubContent_p__fTvy_","sending":"AdFormatSubContent_sending__1bkx9"};